var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9038 9.42643L12.2051 13.1984C12.0806 13.3302 12 13.5207 12 13.6818C12 14.07 12.2637 14.3337 12.6445 14.3337C12.835 14.3337 12.9814 14.2677 13.106 14.1432L14.6294 12.5685L15.8086 11.2062L15.7354 12.8981V22.3097C15.7354 22.6979 16.0063 22.9689 16.3945 22.9689C16.7754 22.9689 17.0464 22.6979 17.0464 22.3097V12.8981L16.9805 11.2062L18.1523 12.5685L19.6831 14.1432C19.8076 14.2677 19.9468 14.3337 20.1372 14.3337C20.5181 14.3337 20.7817 14.07 20.7817 13.6818C20.7817 13.5207 20.7085 13.3302 20.5767 13.1984L16.8853 9.42643C16.6143 9.14078 16.1821 9.12613 15.9038 9.42643Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.d068785b8e162f02346da5c8e835726a.svg";
export { ForwardRef as ReactComponent };